<script setup>
  import { onBeforeUnmount, onMounted, ref } from 'vue'
  import Cleave from 'cleave.js'
  import { LabelField } from '@/components'

  defineProps({
    onKey: {
      type: Function,
      required: false,
    },
    valueData: {
      type: String,
      required: false,
    },
    labelText: {
      type: String,
      required: false,
    },
    addClass: {
      type: String,
      required: false,
    },
    idField: {
      type: String,
      required: false,
    },
    disabledField: {
      type: Boolean,
      default: false,
    },
    requiredField: {
      type: Boolean,
      default: false,
    },
  })

  const cpfInput = ref(null)
  let cleaveInstance = null

  const cleaveOptions = {
    delimiters: ['.', '.', '-'],
    blocks: [3, 3, 3, 2],
    numericOnly: true,
  }

  onMounted(() => {
    if (cpfInput.value) {
      cleaveInstance = new Cleave(cpfInput.value, cleaveOptions)
    }
  })

  onBeforeUnmount(() => {
    if (cleaveInstance) {
      cleaveInstance.destroy()
    }
  })
</script>

<template>
  <LabelField :label-text="labelText" class="mb-2" />
  <input
    ref="cpfInput"
    type="text"
    :id="idField"
    :class="addClass"
    :disabled="disabledField"
    :required="requiredField"
    class="form-control"
    :value="valueData"
    placeholder="000.000.000-00"
    @keyup="({ target: { value } }) => onKey(idField, value)"
  />
</template>
